<template>
  <div v-if="!isJumpSumsub">
    <RegisterTemplate
      :title="$t('verificationStatus.addressVerification')"
      :desc="$t(desc)"
      :activeTab="activeTab"
      :tabs="progressTabs"
    />
  </div>
  <div v-else class="my-10 flex items-start justify-center gap-10 md:mx-10">
    <RegisterFormContainer
      :title="$t('verificationStatus.addressVerification')"
      :desc="$t(desc)"
      :overflow="true"
      class="flex-1"
    >
      <div class="m-8">
        <SumsubPoaKyc @onFailedSumsub="onFailedSumsub" />
      </div>
      <div class="pt-3 pb-8 text-center">
        <el-button class="blue_button" @click="$router.push('/home')">{{ $t('common.button.bkToHm') }}</el-button>
      </div>
    </RegisterFormContainer>
  </div>
</template>

<script>
import RegisterTemplate from '@/components/register/registerTemplate/RegisterTemplate.vue';
import RegisterFormTab from '@/constants/register/registerFormTab';

import registerStep from '@/constants/register/registerStep';
import { RegisterRoutePath } from '@/router/registerRoutes';
import auditStatus from '@/constants/auditStatus';
import { mapGetters, mapState } from 'vuex';
import poaStore from '@/store/register/poaVerification/poaStore';
import { sensorsTrack } from '@/util/sensorsdata';
import { SENSORS_TRACK } from '@/util/sensorsdata/constant';
import { apiGetSumsubJump } from '@/resource';
import RegisterFormContainer from '@/components/register/registerForms/RegisterFormContainer.vue';
import SumsubPoaKyc from '@/components/register/SumsubPoaKyc';

const path = 'poaVerification';

export default {
  name: 'PoaVerification',
  components: { RegisterTemplate, RegisterFormContainer, SumsubPoaKyc },
  data() {
    return {
      tabs: [
        new RegisterFormTab({
          step: registerStep.poaInformation,
          regulator: this.regulator,
          pathName: `${path}/poaInformation`,
          title: 'verificationStatus.poaVerification.poaInformation.stepTitle'
        }),
        new RegisterFormTab({
          step: registerStep.poaUpload,
          regulator: this.regulator,
          pathName: `${path}/poaUpload`,
          title: 'verificationStatus.poaVerification.poaUpload.stepTitle'
        }),
        new RegisterFormTab({
          step: registerStep.poaStatus,
          regulator: this.regulator,
          pathName: `${path}/poaVerificationSuccess`,
          title: 'verificationStatus.depositOrTradeNow'
        }),
        new RegisterFormTab({
          step: registerStep.poaSuccess,
          regulator: this.regulator,
          pathName: `${path}/poaVerificationSuccess`,
          title: 'verificationStatus.depositOrTradeNow'
        })
      ],
      isJumpSumsub: false
    };
  },
  computed: {
    desc() {
      switch (this.activeTab) {
        case registerStep.poaInformation:
          return `verificationStatus.poaVerification.poaInformation.desc`;
        case registerStep.poaUpload:
          return 'verificationStatus.poaVerification.poaUpload.desc';
        default:
          return '';
      }
    },
    poaAuditStatus() {
      return this.$store.state.common.poaAuditStatus;
    },
    ...mapState('register', ['currStep', 'activeTab']),
    ...mapGetters('common', ['isPoaUnderReview', 'isPoaResubmit', 'poaPass']),
    progressTabs() {
      // 为正确显示进度条进行判断
      if (this.isPoaUnderReview) {
        return this.tabs.filter(item => item.step !== registerStep.poaSuccess);
      } else {
        return this.tabs.filter(item => item.step !== registerStep.poaStatus);
      }
    }
  },
  created() {
    poaStore.dispatch('resetPoaInformationForm');
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.isJumpSumsub = await this.getSumsubJump();
      if (!this.isJumpSumsub) {
        this.oldFlowInit();
      }
    },
    async oldFlowInit() {
      if (this.currStep < registerStep.poaInformation) {
        this.$router.push(RegisterRoutePath.register);
      } else if (this.currStep > registerStep.poaUpload) {
        // Submitted and success
        if (this.poaPass) {
          this.setActiveTab(registerStep.poaSuccess);
        }
        // Submitted and pending
        else if (this.isPoaUnderReview) {
          this.setActiveTab(registerStep.poaStatus);
        }
        // Rejected and resubmit
        else if (this.isPoaResubmit) {
          this.setActiveTab(registerStep.poaUpload);
        }
        // Create from admin portal return registerStep (6), poiAuditStatus (auditStatus.init)
        else if (this.poaAuditStatus === auditStatus.init) {
          this.setActiveTab(registerStep.poaInformation);
        }
      } else {
        // Set to first tab and init the sub step
        this.setActiveTab(this.currStep);
      }
      sensorsTrack(SENSORS_TRACK.EVENT_NAME.OPEN_IDENTITY_PAGE_VIEW, {
        openidentity_level: SENSORS_TRACK.IDENTITY_LEVEL.LV3
      });
    },
    setActiveTab(tab) {
      this.$store.dispatch('register/setActiveTab', tab);
    },
    async getSumsubJump() {
      const res = await apiGetSumsubJump({
        type: 2 // poa需要传type2区分,advance需要传type4,5区分
      });
      this.isSumsubJump = res.data.data;
      return res.data.data;
    },
    async onFailedSumsub() {
      this.init();
    }
  }
};
</script>

<style lang="scss" scoped></style>
